import type { Usuario } from '../types/database'
import { getRuntimeEnv } from './runtime-env'

/**
 * Build de desenvolvimento (BUILD_MODE=development no esbuild, ou Vite dev).
 * Lido direto de import.meta.env, e não de getRuntimeEnv, de propósito:
 * assim nenhuma variável de runtime (env.js) reativa o modo local em produção.
 */
const DEV_BUILD = import.meta.env.DEV === true

const supabaseUrl = getRuntimeEnv('VITE_SUPABASE_URL')
const supabaseAnonKey = getRuntimeEnv('VITE_SUPABASE_ANON_KEY')

export const SUPABASE_CONFIGURED = Boolean(
  supabaseUrl &&
    supabaseAnonKey &&
    !supabaseUrl.includes('SEU_PROJETO') &&
    !supabaseUrl.includes('placeholder') &&
    supabaseAnonKey !== 'sua_anon_key' &&
    supabaseAnonKey !== 'placeholder',
)

// import.meta.env.DEV é usado direto (e não via DEV_BUILD) para o esbuild
// dobrar a condição no lugar e eliminar os literais do bundle de produção.
export const DEV_ADMIN_EMAIL = import.meta.env.DEV
  ? getRuntimeEnv('VITE_DEV_ADMIN_EMAIL') || 'admin@isen.educae.br'
  : ''

export const DEV_ADMIN_PASSWORD = import.meta.env.DEV
  ? getRuntimeEnv('VITE_DEV_ADMIN_PASSWORD') || 'Admin@Timon2026'
  : ''

export const OPEN_DEV_PROFILE: Usuario = {
  id: '00000000-0000-0000-0000-000000000001',
  nome: 'Administrador ISEN',
  email: DEV_ADMIN_EMAIL,
  perfil: 'admin',
  ativo: true,
  criado_em: new Date().toISOString(),
}

export function isDevAdminCredentials(email: string, password: string) {
  if (!DEV_BUILD || SUPABASE_CONFIGURED) return false
  if (!DEV_ADMIN_EMAIL || !DEV_ADMIN_PASSWORD) return false
  return (
    email.trim().toLowerCase() === DEV_ADMIN_EMAIL.toLowerCase() &&
    password === DEV_ADMIN_PASSWORD
  )
}

/**
 * Modo local (entra como admin sem login) só existe em build de desenvolvimento
 * sem Supabase configurado. Em produção, faltar configuração é erro — nunca bypass.
 * Legado VITE_AUTH_OPEN / AUTH_OPEN removido (US-R01): não há flag de auth aberta.
 */
export const SKIP_SUPABASE_AUTH = DEV_BUILD && !SUPABASE_CONFIGURED

/** Build de produção sem Supabase configurado: a aplicação não deve abrir. */
export const CONFIG_AUSENTE = !DEV_BUILD && !SUPABASE_CONFIGURED

export const DEV_SESSION_KEY = 'isen_educae_dev_session'
